module.exports = __webpack_public_path__ + "static/media/Trakezie-small-logo.42bf73c3.png";